import {
  NodePermissionService,
  PermissionOptions,
  PermissionSource,
} from '@alfresco/aca-shared';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class WkNodePermissionService {
  constructor(private readonly permissions: NodePermissionService) {}

  check(
    source: PermissionSource | PermissionSource[],
    permissions: string[],
    options?: PermissionOptions
  ): boolean {
    return this.permissions.check(source, permissions, options);
  }
}
